// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"72f6f30a","23":"1a35a5fc","81":"e9591de2","498":"08e1e2c8","513":"69e628f6","607":"da9081fe","703":"f2c60403","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};